import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.67 7.353c1.753 0 3.341.655 4.565 1.72l2.383-2.382v5.956h-5.956l2.395-2.396A5.263 5.263 0 009.67 9.008a5.302 5.302 0 00-5.03 3.64l-1.568-.516c.92-2.773 3.52-4.778 6.598-4.778z" fill="#54585D" fillOpacity=".6" /></svg>);